import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { LocationJson } from 'app/types/entities'
import { useUser } from 'app/utils'
import { useLocationStore } from 'app/stores/StoreContext'
import { logError } from 'lib/logging'

export type UseLocationSettingsReturn = {
  locations: { hits: LocationJson[]; total: number } | undefined
  listError: string | undefined
  canCreateLocation: boolean
}

export function useLocationSettings(): UseLocationSettingsReturn {
  const [searchParams] = useSearchParams()
  const user = useUser()
  const navigate = useNavigate()
  const locationStore = useLocationStore()

  useEffect(() => {
    const query = searchParams.get(`query`) || ``
    locationStore.fetchList({
      search: query || undefined,
      pagination: { page: 0, limit: 100 },
      sort: { field: `name.keyword`, direction: 'ASC' },
    })
  }, [searchParams.toString()])

  const locations = locationStore.list as { hits: LocationJson[]; total: number } | undefined

  useEffect(() => {
    if (locationStore.listError) {
      logError(`location-settings`, `Failed to load locations`, locationStore.listError)
    }
  }, [locationStore.listError])

  useEffect(() => {
    if (locations?.total === 1 && locations?.hits?.length === 1) {
      navigate(`/settings/location-settings/${locations.hits[0].id}/general`, { replace: true })
    }
  }, [locations])

  return {
    locations,
    listError: locationStore.listError,
    canCreateLocation: true,
  }
}
